import { render, staticRenderFns } from "./comp.vue?vue&type=template&id=486bc0ba&scoped=true"
import script from "./comp.vue?vue&type=script&lang=js"
export * from "./comp.vue?vue&type=script&lang=js"
import style0 from "./comp.vue?vue&type=style&index=0&id=486bc0ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486bc0ba",
  null
  
)

export default component.exports